export default __webpack_public_path__ + "static/media/748-mark.ed3b0a8f.svg";